import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import {
  type PropertiesConfigInputVisualEffectModel,
  type WithBulkActions,
} from '@blaze-shared/elements-domain';

import { PropsBuilder } from '../__base/props-builder';

export class TablePropsBuilder extends PropsBuilder<'table'> {
  override setVisualEffect = (
    visualEffect: PropertiesConfigInputVisualEffectModel | undefined,
  ): this => {
    return this.patchProps({ style: { general: { visualEffect } } });
  };

  override removeBulkAction = (action: keyof WithBulkActions): this =>
    this.patchProps({
      content: {
        [action]: undefined,
      },
    });
  constructor(props: PartialPropsOf<'table'> | undefined) {
    super(props, { hasData: true, hasLabel: true });
  }
}
